module.exports = __webpack_public_path__ + "img/undraw_processing_qj6a.0ca7e00c.svg";